<template>
  <section class="core-data">
    <h2 class="section-title">核心数据亮点</h2>
    <p class="subtitle">AI 智能设备助力球房提升运营效率</p>
    <div class="data-grid">
      <div class="data-item">
        <div class="number">32.8%</div>
        <div class="description">球房开台时长提升</div>
      </div>
      <div class="data-item">
        <div class="number">50%+</div>
        <div class="description">年轻客群复购率增长</div>
      </div>
      <div class="data-item">
        <div class="number">2h+</div>
        <div class="description">日均延长开台时长</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CoreData'
}
</script>

<style scoped>
.core-data {
  padding: 4rem 5%;
  background-color: rgba(0, 0, 0, 0.02);
  backdrop-filter: blur(10px);
  position: relative;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.data-grid {
  display: flex;
  justify-content: space-around;
  max-width: 1500px;
  margin: 0 auto;
}

.data-item {
  text-align: center;
  background: #fff;
  padding: 2rem 4rem;
  min-width: 280px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}

.number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #ff0000;
  margin-bottom: 1rem;
}

.description {
  color: #666;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .data-grid {
    flex-direction: column;
    gap: 2rem;
  }
}
</style>